import _classCallCheck from "/home/henry/Desktop/Coherent/productfactory-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/henry/Desktop/Coherent/productfactory-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var Popup = /*#__PURE__*/function () {
  function Popup(parent, custom_html) {
    _classCallCheck(this, Popup);

    this.parent = parent;
    this.custom_html = custom_html;
    this.make();
  }

  _createClass(Popup, [{
    key: "make",
    value: function make() {
      this.parent.innerHTML = "\n            <div class=\"title\"></div>\n            <div class=\"subtitle\"></div>\n            <div class=\"pointer\"></div>\n        ";
      this.title = this.parent.querySelector('.title');
      this.subtitle = this.parent.querySelector('.subtitle');
      this.pointer = this.parent.querySelector('.pointer');
    }
  }, {
    key: "show",
    value: function show(options) {
      this.make();

      if (!options.target_element) {
        throw new Error('target_element is required to show popup');
      }

      if (!options.position) {
        options.position = 'left';
      }

      var target_element = options.target_element;

      if (this.custom_html) {
        var html = this.custom_html(options.task);
        html += '<div class="pointer"></div>';
        this.parent.innerHTML = html;
        this.pointer = this.parent.querySelector('.pointer');
        this.parent.style.width = this.parent.clientWidth + 'px';
      } else {
        this.title.innerHTML = options.task.popup_text;
        this.subtitle.innerHTML = options.subtitle;
        this.parent.style.width = this.parent.clientWidth + 'px';
      } // set position


      var position_meta;

      if (target_element instanceof HTMLElement) {
        position_meta = target_element.getBoundingClientRect();
      } else if (target_element instanceof SVGElement) {
        position_meta = options.target_element.getBBox();
      }

      if (options.position === 'left') {
        //   this.parent.style.left =
        //     position_meta.x + (position_meta.width + 10) + 'px';
        this.parent.style.top = position_meta.y + 'px';
        this.pointer.style.transform = 'rotateZ(90deg)';
        this.pointer.style.left = '-5px';
        this.pointer.style.top = '20px';
      } // show


      this.parent.style.opacity = 1;
    }
  }, {
    key: "updatePosition",
    value: function updatePosition(offsetX, offsetY) {
      this.parent.style.left = offsetX + 40 + 'px';
    }
  }, {
    key: "hide",
    value: function hide() {
      this.parent.innerHTML = '';
    }
  }]);

  return Popup;
}();

export { Popup as default };